(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('treatment-experience-response', {
            parent: 'entity',
            url: '/treatment-experience-response?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.treatmentExperienceResponse.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/treatment-experience-response/treatment-experience-responses.html',
                    controller: 'TreatmentExperienceResponseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('treatmentExperienceResponse');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('treatment-experience-response-detail', {
            parent: 'treatment-experience-response',
            url: '/treatment-experience-response/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.treatmentExperienceResponse.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/treatment-experience-response/treatment-experience-response-detail.html',
                    controller: 'TreatmentExperienceResponseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('treatmentExperienceResponse');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TreatmentExperienceResponse', function($stateParams, TreatmentExperienceResponse) {
                    return TreatmentExperienceResponse.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'treatment-experience-response',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('treatment-experience-response-detail.edit', {
            parent: 'treatment-experience-response-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience-response/treatment-experience-response-dialog.html',
                    controller: 'TreatmentExperienceResponseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TreatmentExperienceResponse', function(TreatmentExperienceResponse) {
                            return TreatmentExperienceResponse.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('treatment-experience-response.new', {
            parent: 'treatment-experience-response',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience-response/treatment-experience-response-dialog.html',
                    controller: 'TreatmentExperienceResponseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                date: null,
                                message: null,
                                name: null,
                                pictureUrl: null,
                                published: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('treatment-experience-response', null, { reload: 'treatment-experience-response' });
                }, function() {
                    $state.go('treatment-experience-response');
                });
            }]
        })
        .state('treatment-experience-response.edit', {
            parent: 'treatment-experience-response',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience-response/treatment-experience-response-dialog.html',
                    controller: 'TreatmentExperienceResponseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TreatmentExperienceResponse', function(TreatmentExperienceResponse) {
                            return TreatmentExperienceResponse.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('treatment-experience-response', null, { reload: 'treatment-experience-response' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('treatment-experience-response.delete', {
            parent: 'treatment-experience-response',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/treatment-experience-response/treatment-experience-response-delete-dialog.html',
                    controller: 'TreatmentExperienceResponseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TreatmentExperienceResponse', function(TreatmentExperienceResponse) {
                            return TreatmentExperienceResponse.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('treatment-experience-response', null, { reload: 'treatment-experience-response' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
